import {Modal} from "@shopify/polaris";
import React from "react";
import intl from "../../../../i18n/intl";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { store } from "../../../../store";
import utils from '../../../../utils/utils'
const UpgradePlanModal = ({num,sourcingOpen,setSourcingOpen}) => {
    const router  = useHistory();
    let person = store.getState().languageReducer.subScriptData;
  return (
    <>
      <Modal
        open={sourcingOpen}
        onClose={() => setSourcingOpen(false)}
        title={'Reach the sourcing limit'}
        primaryAction={(person?.level < 2 || person?.level === 4) ? [
          {
          content: intl.get("Upgrade Plan"),
          onAction: () => {
            setSourcingOpen(false)
            utils.routeListen('/admin/subscribe')
            utils.routeJump1(router,'/admin/subscribe')
          },
        }]:[{
          content: intl.get("OK"),
          onAction: () => setSourcingOpen(false),
        }]}
        secondaryActions={(person?.level < 2 || person?.level === 4) && [
          {
            content: intl.get("Cancel"),
            onAction: () => setSourcingOpen(false),
          },
        ]}
      >
        <Modal.Section>
         {(person?.level < 2 || person?.level === 4) ? 
         <p style={{margin:"10px",fontSize:'14px'}}>
          {intl.get("You have reached your daily sourcing limit of {{num}} , you can upgrade your plan to get more sourcing credits.",num)}</p>
           :<p style={{margin:"10px",fontSize:'14px'}}>
            {intl.get("You have reached your daily sourcing limit of {{num}} , You can initiate the sourcing request again tomorrow.",num)}
            </p>}
        </Modal.Section>
      </Modal>
    </>
  );
};

export default UpgradePlanModal;
